import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Table, TableBody, TableCell, TableHead, TableRow, styled } from '@mui/material';
import React, { useMemo } from 'react';
const StyledTable = styled(Table)({
    width: 'fit-content',
});
StyledTable.defaultProps = { size: 'small' };
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    borderBottom: 'none',
    padding: theme.spacing(0.33, 1, 0.33, 0),
    width: 'fit-content',
    verticalAlign: 'top',
    '&:last-child': {
        paddingRight: 0,
    },
}));
StyledTableCell.defaultProps = { padding: 'none', width: 'content-width', valign: 'top' };
export const PentairDetailsList = ({ data, columns = ['name', 'value'], headings = [], showHeading, ...tableProps }) => {
    const parsedColumns = useMemo(() => {
        return columns || data.reduce((acc, row) => [...new Set([...acc, ...Object.keys(row)])], []);
    }, [data, columns]);
    const parsedData = useMemo(() => {
        return data.map((row) => {
            const key = parsedColumns.reduce((acc, column) => {
                return acc + column + row[column];
            }, '');
            return { ...row, rowKey: key };
        });
    }, [data, parsedColumns]);
    const tableHead = showHeading ? (_jsx(TableHead, { children: _jsx(TableRow, { children: parsedColumns.map((column, index) => (_jsxs(React.Fragment, { children: [_jsx(StyledTableCell, { sx: { paddingBottom: 1 }, children: column in headings ? headings[column] : column }), index === 0 ? (_jsx(StyledTableCell, { sx: { paddingBottom: 1 }, children: headings[column] ? ':' : null })) : null] }, `${index}${column}`))) }) })) : null;
    return (_jsxs(StyledTable, { ...tableProps, children: [tableHead, _jsx(TableBody, { children: parsedData.map(({ rowKey, ...row }) => {
                    return (_jsx(TableRow, { children: parsedColumns.map((column, index) => {
                            const value = row[column];
                            const valueLineBreaks = value.split("\n");
                            const lineBreaksInvalue = valueLineBreaks.length;
                            return (_jsxs(React.Fragment, { children: [_jsx(StyledTableCell, { style: { whiteSpace: String(value).length < 50 ? 'nowrap' : 'normal' }, children: index === 0 ? (_jsx("strong", { children: value })) : (valueLineBreaks.map((line) => (_jsxs(_Fragment, { children: [line, lineBreaksInvalue > 1 && (_jsx("br", {}))] })))) }, rowKey + '_' + column), index === 0 ? (_jsx(StyledTableCell, { style: { whiteSpace: String(value).length < 30 ? 'nowrap' : 'normal' }, children: ':' })) : null] }, `${index}${String(value) ?? ''}`));
                        }) }, rowKey));
                }) })] }));
};
